export enum CopRoutes {
  root = "/",
  loginRoot = "/login",
  idpLogin = "/login/idp",
  copLogin = "/login/cop",
  loginCallback = "/login/callback",
  passwordRoot = "password",
  passwordResetRequest = "/password-reset-request",
  passwordReset = "/password-reset/:passwordResetId",
  admin = "admin",
  invitationsRoot = "/invitations",
  invitation = "/invitations/:invitationId",
  invitationRegistration = "/invitations/:invitationId/registration",
}

export enum CopAdminRoutes {
  organizations = "organizations",
  users = "users",
}
